import type { BaseOption, OptionStateMap } from '@openx/types/options.ts';
import { useDealContext } from '../../../../utils/context/DealContext.tsx';

export const usePartnersFetch = (accountUid: string, isDirectDeal?: boolean): OptionStateMap<BaseOption> => {
  const { useThirdPartyPartnersFetch, useDirectDealsPartnersFetch } = useDealContext();

  const accountPartners = useThirdPartyPartnersFetch(isDirectDeal ? null : accountUid);
  const directDealPartners = useDirectDealsPartnersFetch({ skip: !isDirectDeal });

  return isDirectDeal ? directDealPartners : accountPartners;
};
